import { useAuth } from "../context/AuthContexts";

export const usePermission = () => {
  const { user } = useAuth();

  const can = (permission: string) => user?.permissions?.includes(permission);

  return { can };
};
